/**
 * Model to hold Bout attribute data. This data can be used for a number reasons (e.g. reports)
 */
export class BoutAttribute {
    public static NAME_IS_VARSITY: string = 'is-varsity';
    public static NAME_SEEDING_CRITERIA_PTS: string = 'seeding-criteria-points';

    public id: string = null;
    public name: string = null;
    public value: string = null;
    public comments: string = null;
    public eventId: string = null;
    public boutId: string = null;
    public wrestlerId: string = null;

    /**
     * Clone BoutAttribute object
     */
    public clone(): BoutAttribute {
        const clone: BoutAttribute = new BoutAttribute();
        clone.id = this.id;
        clone.eventId = this.eventId;
        clone.boutId = this.boutId;
        clone.wrestlerId = this.wrestlerId;
        clone.name = this.name;
        clone.value = this.value;
        clone.comments = this.comments;
        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {
            data: {
                id: this.id,
                type: 'boutAttribute',
                attributes: {
                    name: this.name,
                    value: this.value,
                    comments: this.comments,
                },
                relationships: {
                    wrestler: {
                        data: { type: 'wrestler', id: this.wrestlerId },
                    },
                },
            },
        };

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any): BoutAttribute {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};

        this.id = data.id;
        this.name = attrs.name;
        this.value = attrs.value;
        this.comments = attrs.comments;
        this.eventId = attrs.eventId;
        this.boutId = attrs.boutId;
        this.wrestlerId = attrs.wrestlerId;

        return this;
    }
}
